import React, { FC, ReactNode } from 'react';

interface HomePageMobileLayoutProps {
  header: ReactNode;
  sidebar: ReactNode;
  document: ReactNode;
}

const HomePageMobileLayout: FC<HomePageMobileLayoutProps> = ({ header, sidebar, document }) => (
  <div id="home-page-layout-mobile">
    <header id="page-header-mobile">{header}</header>
    <main id="page-body-mobile">
      <section id="sidebar-mobile">{sidebar}</section>
      <section id="document-mobile">{document}</section>
    </main>
  </div>
);

export default HomePageMobileLayout;
